import { analytics, auth, firestore } from "../firebase";

// function to updatePrefences
const moverPreferenceService = {};

// function to updatePrefences
moverPreferenceService.updateServiceAreas = (updatedServiceAreas) => {
    return new Promise((resolve, reject) => {
        const currentUser = auth.currentUser;

        if (!currentUser) {
            reject(new Error("No current user"));

            return;
        }

        const uid = currentUser.uid;

        if (!uid) {
            reject(new Error("No UID"));

            return;
        }

        const userDocumentReference = firestore.collection("users").doc(uid);

        userDocumentReference
            .update({
                serviceAreas: { ...updatedServiceAreas },
            })
            .then((value) => {
                analytics.logEvent("update_service_areas");

                resolve(value);
            })
            .catch((reason) => {
                reject(reason);
            });
    });
};

export default moverPreferenceService;
